module.exports = __webpack_public_path__ + "menu_2.b1f884c3.png";